module.exports = __webpack_public_path__ + "img/shui-ji-shi-logo.6c4a4c07.png";